// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loader_loadingContainer__67XQl","fullscreen":"Loader_fullscreen__iRTSW","loadingText":"Loader_loadingText__ZdeuK"};